export const SET_FORM_SELECTORS_REPORT_DATA = '@@REPORT_SUMMARY/SET_FORM_SELECTORS_REPORT_DATA';
export const SET_TABLE_REPORT_DATA = '@@REPORT_SUMMARY/SET_TABLE_REPORT_DATA';
export const RESET_STATE = '@@REPORT_SUMMARY/RESET_STATE';
export const SET_IS_LOADING = '@@REPORT_SUMMARY/SET_IS_LOADING';